<template>
  <div class="home content-continer" :style="{minHeight:minheight + 'px'}">
    <!-- 最上面搜索 -->
    <div class="continer-top base-content" v-if="!newbuit">
      <el-row :gutter="60">
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <span>项目名称</span>
            <input type="text" placeholder="请输入项目名称" v-model="seachproname" />
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <span>项目状态</span>
            <el-select v-model="delegateState" placeholder="请选择">
              <el-option
                v-for="item in gateStates"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5" style="text-align:right;">
          <div class="grid-content bg-purple">
            <el-button type="primary" icon="el-icon-search" @click="projectlist(1)">搜索</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 下面数据 -->

    <div class="newbuit-content" v-if="newbuit" style="background:none;margin-top:20px;">
      <div class="base-content">
        <div class="buit-title">项目信息</div>
        <!-- 第一行 项目编号-->
        <el-row :gutter="30">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>项目编号</span>
              <input
                type="text"
                v-model="code"
                placeholder="请输入项目编号"
                style="margin-left: 10px;width:920px"
              />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="codeState">{{codeContent}}</span>
          </el-col>
        </el-row>

        <!-- 第二行 项目名称-->
        <el-row :gutter="30">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>项目名称</span>
              <input
                type="text"
                v-model="projectName"
                placeholder="请输入项目名称"
                style="margin-left: 10px;width:920px"
              />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="projectNameState">{{projectNameContent}}</span>
          </el-col>
        </el-row>

        <!-- 第三行 项目描述-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span style="vertical-align:top;padding-top:10px;">项目描述</span>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请填写项目描述"
                v-model="projectDesc"
                style="width:920px"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="projectDescState">{{projectDescContent}}</span>
          </el-col>
        </el-row>

        <!-- 第四行 专业名称-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>专业名称</span>
              <!-- v-model="specialtyvalue" -->
              <el-select v-model="firstLevelName" placeholder="请选择专业名称" @change="specialchange">
                <el-option
                  v-for="item in specialtylist"
                  :key="item.specId"
                  :label="item.specName"
                  :value="item.specId"
                ></el-option>
              </el-select>
              <!-- v-model="speciality" -->
              <el-select v-model="secondLevelName" placeholder="请选择专业名称" value-key="specId" @change="getSecondVal">
                <el-option
                  v-for="item in specialty2"
                  :key="item.specId"
                  :label="item.specName"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span
              class="base-content-project-des"
              v-show="specialtyvalueState"
            >{{specialtyvalueContent}}</span>
          </el-col>
        </el-row>

        <!-- 第五行 项目类型-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>项目类型</span>
              <el-select v-model="phase" placeholder="请选择" value-key="value">
                <el-option
                  v-for="item in phaselist"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="phaseState">{{phaseContent}}</span>
          </el-col>
        </el-row>

        <!-- 第六行 开始时间-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>开始时间</span>
              <el-date-picker
                v-model="startDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="startDateState">{{startDateContent}}</span>
          </el-col>
        </el-row>

        <!-- 第七行 项目负责人-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>项目负责人</span>
              <input
                type="text"
                v-model="managerName"
                placeholder="请填写项目负责人"
                style="margin-left: 10px;"
              />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="managerNameState">{{managerNameContent}}</span>
          </el-col>
        </el-row>

        <!-- 第八行 负责人手机号-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>负责人手机号</span>
              <input
                type="number"
                v-model="managerMobile"
                placeholder="请填写负责人手机号"
                style="margin-left: 10px;"
              />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span
              class="base-content-project-des"
              v-show="managerMobileState"
            >{{managerMobileContent}}</span>
          </el-col>
        </el-row>

        <!-- 第九行 申办方-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>申办方</span>
              <input type="text" placeholder="请填写申办方" v-model="sponsorName" />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="sponsorNameState">{{sponsorNameContent}}</span>
          </el-col>
        </el-row>

        <!-- 第十行 CRC 人数-->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>CRC人数</span>
              <input type="number" placeholder="请填写CRC人数" v-model="crcNum" />
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="crcNumState">{{crcNumContent}}</span>
          </el-col>
        </el-row>
      </div>
      <div class="base-content" style="margin-top: 20px;">
        <!-- 第十一行 公司名称-->
        <div class="buit-title">CRC委派公司信息</div>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <span>公司名称</span>
              <el-select
                v-model="smo"
                placeholder="请输入CRC委派的公司名称"
                filterable
                :filter-method="companyseach"
                value-key="id"
                class="hos-home-add-select"
                no-data-text="请输入CRC委派的公司名称"
              >
                <el-option
                  v-for="item in companys"
                  :key="item.value"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" class="base-content-project">
          <el-col :span="24">
            <span class="base-content-project-des" v-show="smoState">{{smoContent}}</span>
          </el-col>
        </el-row>

        <div class="center">
          <el-button type="info" @click="empty">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </div>
    </div>
    <div v-if="!newbuit">
      <div class="continer-title base-content">
        <div class="blue left" style="margin-top:-10px;">项目信息</div>
        <p class="buit-btn right" style="margin-top:-15px;" @click="add">
          <img src="../assets/hospital-img/add.png" />创建新项目
        </p>
      </div>

      <!-- 项目列表 -->
      <div
        class="base-content item-list"
        v-for="(item,index) in projectlists"
        :key="index"
        v-if="total"
      >
        <div>
          <a class="list-num">{{index+1}}</a>
          <a class="list-name">{{item.projectName}}</a>
          <a class="w-status" v-if="item.delegationState=='1'">
            <img src="../assets/hospital-img/no-w.png" />
          </a>
          <a class="w-status" v-if="item.delegationState=='2'">
            <img src="../assets/hospital-img/s-no-j.png" />
          </a>
          <a class="w-status" v-if="item.delegationState=='3'">
            <img src="../assets/hospital-img/s-y-j.png" />
          </a>
          <a class="w-status" v-if="item.delegationState=='4'">
            <img src="../assets/hospital-img/yes-wc.png" />
          </a>
        </div>
        <ul class="list-msg">
          <li>
            <p>专业名称</p>
            <p>{{item.specialityName?item.specialityName:'无'}}</p>
          </li>
          <li>
            <p>CRC人数</p>
            <p>{{item.crcNum?item.crcNum:'无'}}</p>
          </li>
          <li>
            <p>项目类型</p>
            <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
          </li>
          <li>
            <p>项目开始时间</p>
            <p>{{item.startDate?item.startDate:'无'}}</p>
          </li>
          <li>
            <p>申办方</p>
            <p v-if="item.sponsorName!=''&&item.sponsorName.length>=15">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.sponsorName"
                placement="top-start"
              >
                <el-button>{{item.sponsorName}}</el-button>
              </el-tooltip>
            </p>
            <p v-if="item.sponsorName.length<=15">{{item.sponsorName}}</p>
            <p v-if="item.sponsorName==''">无</p>
          </li>
          <li>
            <p>公司名称</p>
            <p v-if="item.smoName==''">无</p>
            <p v-if="item.smoName.length<=12">{{item.smoName}}</p>
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.smoName"
              placement="top-start"
              v-if="item.smoName!=''&&item.smoName.length>=13"
            >
              <el-button>{{item.smoName}}</el-button>
            </el-tooltip>
          </li>
          
          <div style=" float:right; margin-top: 15px;   margin-right: -10px;">
            <li style="width: auto; margin-right: 5px;" v-if="item.delegationState!='4'">
              <a
                @click="edit(item.id,index)"
                style="cursor: pointer"
                v-if="item.delegationState!='4'"
              >编辑</a>
            </li>
            <li v-if="item.delegationState=='2'" style="width: auto; margin-right: 5px;">
              <router-link :to="`/HIndex/hostipal-item/`+item.id">CRC接收</router-link>
            </li>
            <li v-if="item.delegationState=='3'" style="width: auto; margin-right: 5px;">
              <router-link :to="`/HIndex/hostipal-appraise/`+item.id">评价</router-link>
            </li>
            <li style="width: auto; margin-right: 5px;">
              <router-link :to="`/HIndex/hostipal-items/`+item.id">查看</router-link>
            </li>
          </div>
          
        </ul>
      </div>
      <div class="center" style="margin-bottom: 100px;" v-if="total">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="projectlist"
          :current-page.sync="pageNow"
        ></el-pagination>
      </div>
      <div class="center" style="margin-top: 50px;" v-if="!total">暂无数据</div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getSpecialty } from "@/request/api";
import { addproject } from "@/request/api";
import { editproject } from "@/request/api";
import { companyNmae } from "@/request/api";

import { projectlist } from "@/request/api";
import { secondLevelRequest } from "@/request/api";


export default {
  name: "home",
  data() {
    return {
      
      firstLevelName: '',  // 一级名称
      secondLevelName: '', // 二级名称
      
      userId: "",
      seachproname: "",
      delegateState: "", //项目状态
      pageNow: "1",
      total: 10, //总条数
      projectlists: [], //项目列表
      
      // 增加了额外的 《进行中》 的状态 ，状态值为 5;
      gateStates: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "1",
          label: "待委派"
        },
        {
          value: "2",
          label: "待接收"
        },
        {
          value: "3",
          label: "已接收"
        },
        {
          value: "4",
          label: " 已完成"
        }
      ],
      newbuit: false,
      minheight: this.Common.minheight,
      options: [],
      companys: [],
      specialtylist: [], //专业一级菜单
      specialty2: [], //专业二级菜单
      input: "",
      value: "",
      phaselist: [
        {
          value: "1",
          label: "Ⅰ期"
        },
        {
          value: "2",
          label: "Ⅱ期"
        },
        {
          value: "3",
          label: "Ⅲ期"
        },
        {
          value: "4",
          label: " Ⅳ期"
        }
      ],
      loading: false,

      code: "", // 项目编号              （1）
      projectName: "", // 新建项目名称           (2)
      projectDesc: "", // 项目描述               (3)
      specialtyvalue: "1", // 专业一级选中项         (4-1)
      speciality: "", // 专业二级菜单选中项      (4-2)
      phase: "", // 项目类型,              (5)
      startDate: "", // 项目开始时间           (6)
      managerName: "", // 负责人名称             (7)
      managerMobile: "", // 负责人手机号           (8)
      sponsorName: "", // 申办方名称             (9)
      crcNum: "", // crc 人数              (10)
      smo: "", // 公司id和name          (11)

      // 输入框验证错误的提示信息
      codeContent: "", // (1)
      projectNameContent: "", // (2)
      projectDescContent: "", // (3)
      specialtyvalueContent: "", // (4)
      phaseContent: "", // (5)
      startDateContent: "", // (6)
      managerNameContent: "", // (7)
      managerMobileContent: "", // (8)
      sponsorNameContent: "", // (9)
      crcNumContent: "", // (10)
      smoContent: "", // (11)

      // 输入框验证错误信息的状态
      codeState: false, // (1)
      projectNameState: false, // (2)
      projectDescState: false, // (3)
      specialtyvalueState: false, // (4)
      phaseState: false, // (5)
      startDateState: false, // (6)
      managerNameState: false, // (7)
      managerMobileState: false, // (8)
      sponsorNameState: false, // (9)
      crcNumState: "", // (10)
      smoState: false, // (11)

      craNum: "",
      smoName: "",
      smoId: "",

      editstatus: "",
      ids: ""
    };
  },
  methods: {
    getSecondVal(val){
      this.speciality = val.specId;
    },
    // 项目编号 --- 验证处理（1）
    checkTipsNum() {
      if (this.code) {
        this.codeContent = "";
        this.codeState = false;
        return true;
      } else {
        this.codeContent = "* 请填写项目编号";
        this.codeState = true;
        return false;
      }
    },

    // 项目名称 --- 验证处理（2）
    checkProjectName() {
      if (this.projectName) {
        let tempProjectName = this.removeAllSpace(this.projectName);
        // 纯数字的验证(整数或者小数)
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        // 纯特殊字符
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]+$/;

        // 纯数字的验证
        // 纯特殊字符
        if (
          myregNum.test(tempProjectName) ||
          myregParti.test(tempProjectName)
        ) {
          this.projectNameContent =
            "* 项目名称不合法,请勿输入纯数字或者纯特殊字符";
          this.projectNameState = true;
          return false;
        } else {
          this.projectNameContent = "";
          this.projectNameState = false;
          return true;
        }
      } else {
        this.projectNameContent = "* 请填写项目名称";
        this.projectNameState = true;
        return false;
      }
    },

    // 去除所有空格的处理
    removeAllSpace(str) {
      return str.replace(/\s+/g, "");
    },

    // 项目描述 --- 验证处理（3）
    checkProjectDesc() {
      if (this.projectDesc) {
        let tempProjectDesc = this.removeAllSpace(this.projectDesc);
        // 纯数字的验证(整数或者小数)
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        // 纯特殊字符
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]+$/;

        if (
          myregNum.test(tempProjectDesc) ||
          myregParti.test(tempProjectDesc)
        ) {
          this.projectDescContent =
            "* 项目描述输入不合法,请勿输入纯数字或者纯特殊字符";
          this.projectDescState = true;
          return false;
        } else {
          this.projectDescContent = "";
          this.projectDescState = false;
          return true;
        }
      } else {
        this.projectDescContent = "* 请填写项目描述";
        this.projectDescState = true;
        return false;
      }
    },

    // 专业名称 --- 验证处理（4）
    checkProjectPro() {
      if (this.specialtyvalue && this.speciality) {
        this.specialtyvalueContent = "";
        this.specialtyvalueState = false;
        return true;
      } else {
        this.specialtyvalueContent = "* 请选择专业名称";
        this.specialtyvalueState = true;
        return false;
      }
    },

    // 项目类型 --- 验证处理（5）
    checkProjectType() {
      if (this.phase) {
        this.phaseContent = "";
        this.phaseState = false;
        return true;
      } else {
        this.phaseContent = "* 请选择项目类型";
        this.phaseState = true;
        return false;
      }
    },

    // 开始时间 --- 验证处理（6）
    checkProjectStart() {
      if (this.startDate) {
        this.startDateContent = "";
        this.startDateState = false;
        return true;
      } else {
        this.startDateContent = "* 请选择项目开始时间";
        this.startDateState = true;
        return false;
      }
    },

    // 项目负责人 --- 验证处理（7）
    checkProjectMan() {
      if (this.managerName) {
        let myregNum = /[0-9]/gim;
        let myregParti = /[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
        if (
          myregNum.test(this.managerName) ||
          myregParti.test(this.managerName)
        ) {
          this.managerNameContent = "* 姓名格式不正确";
          this.managerNameState = true;
          return false;
        } else {
          this.managerNameContent = "";
          this.managerNameState = false;
          return true;
        }
      } else {
        this.managerNameContent = "* 请输入项目负责人姓名";
        this.managerNameState = true;
        return false;
      }
    },

    // 项目负责人手机号 --- 验证处理（8）   待修改 tips
    checkPhoneNum() {
      if (this.managerMobile) {
        let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(this.managerMobile)) {
          this.managerMobileContent = "* 手机号码格式错误，请重新输入！";
          this.managerMobileState = true;
          return false;
        } else {
          this.managerMobileContent = "";
          this.managerMobileState = false;
          return true;
        }
      } else {
        this.managerMobileContent = "* 请输入项目负责人手机号码";
        this.managerMobileState = true;
        return false;
      }
    },

    // 申办方 --- 验证处理（9）
    checkProjectObj() {
      if (this.sponsorName) {
        let tempSponsorName = this.removeAllSpace(this.sponsorName);
        // 纯数字的验证(整数或者小数)
        let myregNum = /^[0-9]+\.{0,1}[0-9]{0,2}$/;
        // 纯特殊字符
        let myregParti = /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]+$/;

        if (
          myregNum.test(tempSponsorName) ||
          myregParti.test(tempSponsorName)
        ) {
          this.sponsorNameContent =
            "* 申办方信息不合法，请勿输入纯数字或者纯特殊字符";
          this.sponsorNameState = true;
          return false;
        } else {
          this.sponsorNameContent = "";
          this.sponsorNameState = false;
          return true;
        }
      } else {
        this.sponsorNameContent = "* 请填写申办方信息";
        this.sponsorNameState = true;
        return false;
      }
    },

    // crc 人数 --- 验证处理 （10）
    checkCrcNum() {
      if (this.crcNum) {
        let myPhone = /^\+?[1-9][0-9]*$/;
        if (!myPhone.test(this.crcNum)) {
          this.crcNumContent = "* 请输入非0正整数";
          this.crcNumState = true;
          return false;
        } else {
          this.crcNumContent = "";
          this.crcNumState = false;
          return true;
        }
      } else {
        this.crcNumContent = "* 请填写 CRC 人数";
        this.crcNumState = true;
        return false;
      }
    },

    // 公司名称 --- 验证处理（11）
    checkProjectCompany() {
      if (this.smo) {
        this.smoContent = "";
        this.smoState = false;
        return true;
      } else {
        this.smoContent = "* 请输入公司名称";
        this.smoState = true;
        return false;
      }
    },

    // 搜索公司名称
    companyseach(val) {
      // this.smoName = val;
      // alert(val);
      companyNmae(val)
        .then(res => {
          console.log(res.data.data);
          this.companys = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 新增项目专业选择
    specialchange() {
      getSpecialty(this.specialtyvalue)
        .then(res => {
          this.specialty2 = res.data.data;
          this.specialityId = "";
          console.log(this.specialty2);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 新增编辑项目提交
    empty() {
      this.newbuit = false;
      this.projectName = "";
      this.managerName = "";
      this.phase = "";
      this.smo = "";
      this.crcNum = "";
      this.sponsorName = "";
      this.startDate = "";
      this.projectDesc = "";
      this.managerMobile = "";
      this.code = "";
    },
    add() {
      this.empty();
      this.newbuit = true;
      this.editstatus = "0";
    },

    edit(id, index) {
      this.editstatus = "1";
      // alert(this.editstatus);
      this.newbuit = true;
      this.ids = id;
      this.projectName = this.projectlists[index].projectName;
      this.managerName = this.projectlists[index].managerName;
      this.phase = {
        value: "" + this.projectlists[index].phase + "",
        label: "" + this.projectlists[index].phaseDesc + ""
      };
      this.projectDesc = this.projectlists[index].projectDesc;
      this.smo = this.projectlists[index].smoName;
      this.smoName = this.projectlists[index].smoName;
      this.smoId = this.projectlists[index].smoId;
      this.startDate = this.projectlists[index].startDate;
      this.crcNum = this.projectlists[index].crcNum;
      this.sponsorName = this.projectlists[index].sponsorName;
      this.managerMobile = this.projectlists[index].managerMobile;
      this.code = this.projectlists[index].code;
      
      // 锚点设置一级参数
      this.secondLevelName = this.projectlists[index].specialityName;
      this.speciality = this.projectlists[index].specialityId;
      
      // 请求二级数据，设置参数
      this.secondLevelRequest(this.speciality);
    },

    // 请求一级id
    secondLevelRequest:async function(param){
      try{
        let secondData = await secondLevelRequest(param);
        if(secondData.data.code == '0000'){
          this.firstLevelGetName(secondData.data.data.parentId);
        }else{
          this.$message.error("一级专业名称数据获取失败！");
        }
      }catch(error){
        console.log(error);
      }
    },

    // 通过一级id 请求一级名称
    firstLevelGetName:async function(param){
      try{
        let secondData = await secondLevelRequest(param);
        if(secondData.data.code == '0000'){
          this.firstLevelName = secondData.data.data.specName;
          this.specialtyvalue = param;
        }else{
          this.$message.error("一级专业名称数据获取失败！");
        }
      }catch(error){
        console.log(error);
      }
    },
    
    submit() {
      let userId = Cookies.get("userid");

      // if (this.sponsorName == "") {
      //   this.$message.error("申办方不能为空");
      // } else

      if (
        !(
          this.checkTipsNum() &&
          this.checkProjectName() &&
          this.checkProjectDesc() &&
          this.checkProjectPro() &&
          this.checkProjectType() &&
          this.checkProjectStart() &&
          this.checkProjectMan() &&
          this.checkPhoneNum() &&
          this.checkProjectObj() &&
          this.checkCrcNum() &&
          this.checkProjectCompany()
        )
      ) {
        console.log("有参数未通过验证,验证处理失败");
      } else {
        console.log("参数验证通过");
        if (this.editstatus == "1") {
          //  alert(this.crcNum);
          let data = {
            userId: userId,
            projectName: this.projectName,
            managerName: this.managerName,
            phase: this.phase.value,
            phaseDesc: this.phase.label,
            smoName: this.smoName,
            smoId: this.smoId,
            crcNum: this.crcNum,
            sponsorName: this.sponsorName,
            startDate: this.startDate,
            specialityId: this.speciality.specId,
            specialityName: this.speciality.specName,
            projectDesc: this.projectDesc,
            id: this.ids,
            managerMobile: this.managerMobile,
            code: this.code
          };
          editproject(data)
            .then(res => {
              if (res.data.code == "00000") {
                this.newbuit = false;
                this.projectlist();

                this.$message({
                  message: "修改成功",
                  type: "success"
                });
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          let data = {
            userId: userId,
            projectName: this.projectName,
            managerName: this.managerName,
            phase: this.phase.value,
            phaseDesc: this.phase.label,
            smoName: this.smo.name,
            smoId: this.smo.id,
            crcNum: this.crcNum,
            craNum: this.craNum,
            sponsorName: this.sponsorName,
            startDate: this.startDate,
            specialityId: this.speciality.specId,
            specialityName: this.speciality.specName,
            projectDesc: this.projectDesc,
            managerMobile: this.managerMobile,
            code: this.code
          };
          addproject(data)
            .then(res => {
              if (res.data.code == "00000") {
                this.newbuit = false;
                this.projectlist();
                this.$message({
                  message: "添加项目成功",
                  type: "success"
                });
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    },
    // 获取项目列表
    projectlist(page, event) {
      if (page != undefined) {
        this.pageNow = page;
      } else if (typeof event == "number") {
        this.pageNow = event;
      }
      this.newbuit = false;

      let projectseach = {
        delegateState: this.delegateState,
        pageIndex: this.pageNow,
        pageSize: "5",
        projectName: this.seachproname,
        userId: Cookies.get("userid")
      };
      projectlist(projectseach)
        .then(res => {
          console.log("终极无敌dabug~", res.data.data);
          let pagedata = res.data.data;
          this.total = pagedata.total;
          this.projectlists = pagedata.list;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    
    // 路由传递的参数的处理
    if(this.$route.query.id){
      this.routerParam = this.$route.query.id
      if(this.routerParam === 3){ // 已完成项目数
        this.delegateState = 4;
      }else if(this.routerParam === 1){  // 项目总数
        this.delegateState = "";
      }else if(this.routerParam === 2){  // 正在进行项目数
        this.delegateState = 5;
      }
    }else{
      this.routerParam = 0;
    }

    // 获取用户id
    this.userId = Cookies.get("userid");
    // 获取项目列表
    this.projectlist();
    // 新增项目一级菜单选择
    getSpecialty(0)
      .then(res => {
        this.specialtylist = res.data.data;
        console.log(this.specialtylist);
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newbuit-content .el-row {
  /* margin-bottom: 30px; */
}

.el-input__prefix {
  left: 15px;
}

.el-textarea {
  width: auto;
}

.el-textarea textarea {
  width: 926px;
  margin-left: 10px;
  min-height: 40px !important;
  border-radius: 2px;
  border-collapse: #ccc;
  display: inline-block;
}

.item-list {
  position: relative;
}

.list-msg {
  margin-top: 30px;
}

.list-msg li {
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
}

.list-msg li p:first-child {
  color: #999999;
}

.list-msg li p:last-child {
  color: #666666;
  margin-top: 8px;
}

.w-status {
  position: absolute;
  right: 0px;
  top: 0px;
}

.list-msg li:first-child {
  width: 120px;
}

.list-msg li:nth-child(2) {
  width: 60px;
}

.list-msg li:nth-child(3) {
  width: 60px;
}

.list-msg li:nth-child(4) {
  width: 92px;
}

.list-msg li:nth-child(5) {
  width: 220px;
}

.list-msg li:nth-child(6) {
  width: 200px;
}

.list-msg li:last-child {
  margin-right: 0px;
}

.el-textarea {
  margin-left: 10px !important;

  width: 900px;
}

.buit-title {
  height: 60px;
  line-height: 60px;
  margin-bottom: 40px;
  padding-left: 30px;
  border-bottom: solid 1px #f5f5f5;
  color: #4d4d4d;
  font-size: 18px;
  font-weight: bold;
}

/* 输入验证的提醒样式 2019/9/5 增加开始*/
.base-content-project {
  height: 30px;
}

.base-content-project el-col {
  border: 1px solid green;
}

.base-content-project-des {
  color: red;
  font-size: 14px;
  padding-left: 120px;
}
.item-list >>> .el-button {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
  height: auto;
  padding: 0px;
  text-align: left;
}
.item-list >>> .el-button:hover {
  background: #fff;
  color: #666;
}
.hos-home-add-select {
  width: 900px;
  /* border: 1px solid red; */
}
.hos-home-add-select >>> input {
  width: 900px;
}
/* 输入验证的提醒样式 2019/9/5 增加结束*/
</style>


// WEBPACK FOOTER //
// src/hospital/home.vue